import { NgModule } from '@angular/core';
import { LoginService } from '@tech-services/login.service';
import { CommonService } from '@tech-services/common.service';
import { SessionService } from '@tech-services/session.service';

import { LoginGuardian } from '@tech-services/loginGuardian.service';
import { ProfileportfolioService } from '@tech-services/profileportfolio.service';
import { DocmanagerService } from '@tech-services/docmanager.service';
import { FormatsService } from '@techrules/pipelib';

const APP_PROVIDERS = [
  CommonService,
  FormatsService,
  LoginService,
  LoginGuardian,
  SessionService,
  ProfileportfolioService,
  DocmanagerService,
];

@NgModule({
  id: 'tech-core-module',
  providers: APP_PROVIDERS,
  declarations: [],
})
export class CoreModule {}
